import { Else, If, Then } from 'react-if';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { Colors } from '@zep/ui-tokens';
import { StoreCategoryString } from '../../../../consts';
import { useStorePopularItems } from '../../../../services';
import { StoreItemType } from '../../../../types/StoreTypes';
import { ChevronRightIcon } from '../../../icons';
import Empty from '../../common/Empty';
import StoreGrid from './StoreGrid';
import S from './StoreList.module.scss';

/**
 * 에셋 리스트를 출력하는 그리드에 제목이 붙은 컴포넌트
 */
const StorePopularList = (storeTitledListProps: StorePopularListProps) => {
  const {
    type
  } = storeTitledListProps;
  const {
    locale
  } = useRouter();
  const {
    user
  } = useAuth();
  const {
    t
  } = useTranslation(['store']);
  const items = useStorePopularItems(type, !!user?.isEdu, locale);
  const filteredItems = items?.data?.filter(value => value) ?? null;
  const listInformation = {
    [StoreCategoryString.map]: {
      showMoreLink: '/store/assets?type=map&page=1&order=popular',
      title: t('store:store_asset_map')
    },
    [StoreCategoryString.object]: {
      showMoreLink: '/store/assets?type=object&page=1&order=popular',
      title: t('store:store_asset_object')
    },
    [StoreCategoryString.app]: {
      showMoreLink: '/store/assets?type=app&page=1&order=popular',
      title: t('store:store_asset_app')
    },
    [StoreCategoryString.game]: {
      showMoreLink: '/store/assets?type=game&page=1&order=popular',
      title: t('store:store_asset_game')
    }
  };
  return <div className={S.main_wrapper} data-sentry-component="StorePopularList" data-sentry-source-file="StorePopularList.tsx">
      <div className={S.title_wrapper}>
        <h3 className={S.contents_title}>
          {t('store:store_popular_assets', {
          x: listInformation[type].title
        })}
        </h3>
        <Link href={listInformation[type].showMoreLink} passHref prefetch={false} data-sentry-element="Link" data-sentry-source-file="StorePopularList.tsx">
          <span className={S.show_more}>
            {t('store:store_show_all')}
            <ChevronRightIcon fill={Colors.PrimaryDefault} width={20} height={20} data-sentry-element="ChevronRightIcon" data-sentry-source-file="StorePopularList.tsx"></ChevronRightIcon>
          </span>
        </Link>
      </div>
      <If condition={(filteredItems?.length ?? 0) > 0} data-sentry-element="If" data-sentry-source-file="StorePopularList.tsx">
        <Then data-sentry-element="Then" data-sentry-source-file="StorePopularList.tsx">
          <StoreGrid items={filteredItems!} type={type} data-sentry-element="StoreGrid" data-sentry-source-file="StorePopularList.tsx" />
        </Then>
        <Else data-sentry-element="Else" data-sentry-source-file="StorePopularList.tsx">
          <div className={S.empty_wrapper}>
            <Empty emptyItem={listInformation[type].title} data-sentry-element="Empty" data-sentry-source-file="StorePopularList.tsx" />
          </div>
        </Else>
      </If>
    </div>;
};
export default StorePopularList;
type StorePopularListProps = {
  type: StoreItemType;
};